import bbApi from "../../api"
import { downloadPdfFromApi } from "./downloadFile"

export async function handleInvoiceDownload(
  org_id: number,
  invoice: string,
  filename?: string
) {
  try {
    const response = await bbApi.billing.fetchBillingPdf(org_id, invoice)
    const { file, label } = response

    return await downloadPdfFromApi(
      { file, label },
      filename || (label ? `${label}.pdf` : "invoice.pdf")
    )
  } catch (e) {
    return false
  }
}
